export { default } from './AnswerItem';
